export default "/static/assets/sales.53cc1623bd7dcf283b6bc29c1e1c81a2.svg";